var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.id + "Label",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg modal-dialog-centered",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                { staticClass: "modal-title", attrs: { id: _vm.id + "Label" } },
                [
                  _vm._v("Carnet d'adresses\n                    "),
                  "shipping" === _vm.type
                    ? _c("span", [_vm._v("de livraison")])
                    : _vm._e(),
                  _vm._v(" "),
                  "billing" === _vm.type
                    ? _c("span", [_vm._v("de facturation")])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  },
                  on: { click: _vm.back }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              !_vm.isNewAddress && !_vm.isEditAddress
                ? _c(
                    "div",
                    { staticClass: "blockAddressesBook" },
                    [
                      _vm._l(_vm.filteredAddresses, function(item) {
                        return _c(
                          "div",
                          {
                            staticClass: "itemAddressesBook",
                            attrs: { "data-id": item.id }
                          },
                          [
                            _c("div", { staticClass: "float-right" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "btn btn-primary btnEdit",
                                  on: {
                                    click: function($event) {
                                      _vm.editAddress(item)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "svg",
                                    attrs: {
                                      src: "/bundles/site/img/icoEdit.svg",
                                      alt: "Modifier"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn btn-primary btnDelete",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteAddress(item.id)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "svg",
                                    attrs: {
                                      src: "/bundles/site/img/icoSupprimer.svg",
                                      alt: "Supprimer"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn btn-primary btnChoose",
                                  on: {
                                    click: function($event) {
                                      _vm.selectAddress(item)
                                    }
                                  }
                                },
                                [_vm._v("Choisir")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", { staticClass: "headerTitle" }, [
                                _c("i", { staticClass: "fa fa-home" }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.title) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  _vm._s(item.firstname) +
                                    " " +
                                    _vm._s(item.lastname)
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  _vm._s(item.number) +
                                    " " +
                                    _vm._s(item.address1)
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  _vm._s(item.zipcode) + " " + _vm._s(item.city)
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [_vm._v(_vm._s(item.country.name))]),
                              _vm._v(" "),
                              _c("li", [_vm._v(_vm._s(item.phone))])
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.filteredAddresses.length === 0
                        ? _c("div", [
                            _vm._v(
                              "\n                        Vous n'avez pas d'adresses\n                    "
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isNewAddress || _vm.isEditAddress,
                      expression: "isNewAddress || isEditAddress"
                    }
                  ]
                },
                [
                  _c(
                    "form",
                    {
                      attrs: {
                        id: _vm.slotName,
                        name: _vm.formName,
                        method: "post",
                        novalidate: "novalidate",
                        autocomplete: "off"
                      },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          _vm.submitAddress($event)
                        }
                      }
                    },
                    [_vm._t(_vm.slotName), _vm._v(" "), _vm._m(0)],
                    2
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.showBack()
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: { click: _vm.back }
                    },
                    [_vm._v("Retour")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNewAddress && !_vm.isEditAddress
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.newAddress()
                        }
                      }
                    },
                    [_vm._v("Ajouter une adresse")]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { id: "addressSubmit", type: "submit" }
        },
        [_vm._v("Valider")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d3d6074", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d3d6074","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Order/OrderAddressesModal.vue
// module id = 570
// module chunks = 1